import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { getSearchTermSelector, searchRequestAction } from 'pages/search.page';
import {
  collectionCurrentPageSelector,
  collectionSelector,
  collectionVideosSelector,
  getCurrentPageNumberSelector,
  getVideosPerPageSelector,
  integrationSelector,
  websiteSelector,
} from 'common/selectors';
import { urlVideoIdSelector } from 'pages/channel.page';
import { urlSortSelector } from 'common/selectors/router';
import { collectionResetAction } from 'common/actions';
import { PageDecorated } from 'pages/page';
import { VideoBoxDecorated } from 'components/video-box';
import { videoBoxRequestAction } from 'components/video-box/actions';
import { VideoControlsMenu } from './fragments/video-controls-menu';
import { decodeUriParam } from 'utils';
import { isIframe } from 'integration/integration.utils';
import { Header } from 'components/header';
import { ContentBox } from 'components/content-box';
import { VideoListDecorated } from 'components/video-list';
import { VideoCollection } from 'components/video-collection';
import { SORTING_KEYS } from 'utils/enums';
import { searchRequestOnMobileAction } from 'pages/search.page/actions';
import { VideoContextMenuDecorated } from '../../components/video-context-menu';
import { withTranslation } from 'react-i18next';
import { searchSelector } from 'common/selectors/search';

class SearchPage extends React.Component {
  componentWillUnmount() {
    this.props.dispatch(collectionResetAction());
  }

  render() {
    const baseUrl = `/search/${this.props.searchTerm}`;
    const { t } = this.props;

    return (
      <PageDecorated>
        {this.props.videoId && (
          <VideoBoxDecorated
            playerConfiguration={this.props.website.playerConfiguration}
            videoBoxRequestAction={videoBoxRequestAction(this.props.videoId)}
            withRelatedVideos={false}
            inlineVideoControls={VideoControlsMenu}
          />
        )}

        <div>
          {isIframe(this.props.integration) && <Header />}

          <ContentBox>
            {this.props.collection.totalCount > 0 && (
              <div className="row no-gutters">
                <h1 className="title" data-e2e="title">
                  {t('search_results_for')} "{decodeUriParam(this.props.searchTerm, !this.props.search.searchedByForm)}
                  ": {this.props.collection.totalCount}
                </h1>
              </div>
            )}

            {this.props.collection.totalCount === 0 && !this.props.collection.isLoading && (
              <React.Fragment>
                <h1 data-e2e="search-videos-not-found">{t('no_videos_found')}</h1>
                <p className="no-videos-message">
                  {t('no_videos_matching') + ' '} "
                  {decodeUriParam(this.props.searchTerm, !this.props.search.searchedByForm)}"
                </p>
              </React.Fragment>
            )}

            <VideoCollection
              baseUrl={baseUrl}
              withSort={true}
              sortBy={[SORTING_KEYS.relevance, SORTING_KEYS.display_date, SORTING_KEYS.title_asc, SORTING_KEYS.plays]}
              loadCollectionAction={searchRequestAction(
                decodeUriParam(this.props.searchTerm, !this.props.search.searchedByForm),
                this.props.perPage,
                this.props.pageNumber,
                this.props.sort
              )}
              loadMoreAction={searchRequestOnMobileAction(
                decodeUriParam(this.props.searchTerm, !this.props.search.searchedByForm),
                this.props.perPage,
                this.props.collectionPageNumber,
                this.props.collectionVideos,
                this.props.sort
              )}
            >
              <VideoListDecorated baseUrl={baseUrl} contextMenu={VideoContextMenuDecorated} />
            </VideoCollection>
          </ContentBox>
        </div>
      </PageDecorated>
    );
  }
}

export const SearchPageDecorated = compose(
  withTranslation(),
  connect(
    (state, props) => ({
      collection: collectionSelector(state),
      collectionVideos: collectionVideosSelector(state),
      collectionPageNumber: collectionCurrentPageSelector(state),
      pageNumber: getCurrentPageNumberSelector(state, props.match),
      searchTerm: getSearchTermSelector(state, props.match),
      videoId: urlVideoIdSelector(state, props.match),
      website: websiteSelector(state),
      sort: urlSortSelector(state, props.match),
      integration: integrationSelector(state),
      perPage: getVideosPerPageSelector(state),
      search: searchSelector(state),
    }),
    (dispatch) => ({ dispatch })
  )
)(SearchPage);

export * from './selectors';
export * from './actions';
export * from './saga';
export * from './effects';
